import React, { useEffect, useState } from 'react';
import { StatCard } from '../../components/ui/StatCard';
import { Card } from '../../components/ui/Card';
import { Table, Tr, Td } from '../../components/ui/Table';
import { Badge } from '../../components/ui/Badge';
import { getBookings } from '../../api/bookings';
import { getWallet } from '../../api/wallet';
import { Booking, Wallet } from '../../types';
import { formatCurrency, formatDate } from '../../utils/format';
import { useAuth } from '../../hooks/useAuth';

export const AgentDashboard: React.FC = () => {
  const { user } = useAuth();
  const [bookings, setBookings] = useState<Booking[]>([]);
  const [wallet, setWallet] = useState<Wallet | null>(null);

  useEffect(() => {
    getBookings().then(r => setBookings(r.data.results || r.data));
    getWallet().then(r => setWallet(r.data));
  }, []);

  const confirmed = bookings.filter(b => b.status === 'confirmed').length;

  return (
    <div>
      <h1 style={{ fontSize: 20, fontWeight: 500, marginBottom: 4 }}>Dashboard</h1>
      <div style={{ fontSize: 13, color: '#888780', marginBottom: 20 }}>{user?.name} · {user?.role?.replace('_', ' ')}</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 20 }}>
        <StatCard label="Total booking" value={bookings.length} sub={`${confirmed} confirmed`} />
        <StatCard label="Saldo wallet" value={wallet ? formatCurrency(wallet.balance) : '—'} sub="Komisi terkumpul" />
        <StatCard label="Booking bulan ini" value={bookings.filter(b => new Date(b.created_at).getMonth() === new Date().getMonth()).length} />
      </div>
      <Card title="Booking terbaru">
        <Table headers={['Kode', 'Hotel', 'Kamar', 'Tamu', 'Checkin', 'Total', 'Status']}>
          {bookings.slice(0, 10).map(b => (
            <Tr key={b.id}>
              <Td><span style={{ fontFamily: 'monospace', fontSize: 11 }}>{b.booking_code}</span></Td>
              <Td style={{ fontSize: 12 }}>{b.hotel_name}</Td>
              <Td style={{ fontSize: 12 }}>{b.room_type}</Td>
              <Td style={{ fontSize: 12 }}>{b.guest_name}</Td>
              <Td style={{ fontSize: 12 }}>{formatDate(b.checkin_date)}</Td>
              <Td style={{ fontWeight: 500 }}>{formatCurrency(b.total_price)}</Td>
              <Td><Badge status={b.status} /></Td>
            </Tr>
          ))}
        </Table>
      </Card>
    </div>
  );
};
